
    export default 
    {
    "aeAccountDisconnect": {
        "title": "Ihr DSers-Konto ist nicht mehr mit AliExpress verbunden. Dadurch sind die Bestell- und Produktdaten vorübergehend verschwunden. Die Daten werden wiederhergestellt, nachdem Sie ein neues AliExpress-Konto eingerichtet haben."
    }
}